<ng-container *ngIf="video$ | async as video">
    <div>
        <p>Name: {{ video.name }}</p>
        <p>Created: {{ video.created | utcToLocal}}</p>
        <p>Resolution: {{ video.width }}x{{ video.height }}</p>
        <p>Preview:</p>
        <app-video-player [videoUrl]="video.url"></app-video-player>
    </div>
</ng-container>